export const CUSTOMER_NOT_SUFFICIENT_ERROR = 'CustomerNotSufficientError';
export const GENERIC_NOT_FOUND_ERROR = 'notFound';
export const CART_NOT_FOUND_ERROR = 'Cart not found.';
export const UNAUTHORIZED_ERROR = 'UnauthorizedError';
export const REQUIRES_HARD_LOGIN_ERROR = 'RequireHardLoginError';
export const PASSWORD_UPDATE_REQUIRED = 'passwordUpdateRequired';
export const INVALID_TOKEN_ERROR = 'InvalidTokenError';
export const CUSTOMER_RISK_CHECK_ERROR = 'CustomerRiskCheckError';
export const APPLE_PAY_SESSION_REQUIRED = 'applePaySessionRequired';

/**
 * Abbreviation "SDND" stands for "Same Day Next Day".
 * @see https://bitbucket.fressnapf.de/projects/AUR/repos/hybris/browse/core-customize/hybris/bin/custom/fn/fncore/src/com/fressnapf/core/order/exception/UnsupportedSDNDDeliveryModeException.java
 */
export const UNSUPPORTED_SDND_DELIVERY_MODE_ERROR = 'UnsupportedSDNDDeliveryModeError';

// possible BE errors which doesn't mean the order fails, just need more time to place the order in BE side
export const ORDER_RETRY_ERRORS_FOR_PAYMENTS = [
  'JaloObjectNoLongerValidError',
  'retryLater',
  'LockTimeoutError',
  'LockedModelRemovedError',
];

export const isPlaceOrderRetryError = (error: any) => {
  return ORDER_RETRY_ERRORS_FOR_PAYMENTS.includes(error?.response?.data?.errors?.[0].type);
};

export const isPaymentRefusedError = (error: any) => {
  const _error = error?.response?.data?.errors?.[0];
  return _error?.type === 'PaymentError' && _error?.subject === 'Refused';
};

/**
 * Checks whether a response error is coming from the backend API,
 * and has a given status with optionally matching error message(s).
 */
export const isResponseError = (error: any, status: number | '*', messages: string | Array<string> = []) => {
  const errors = error?.response?.data?.errors || Array(error?.response?.data);
  const errorMessages = Array.isArray(messages) ? messages : [messages];

  // Compare status code, or bypass when we receive a '*' wildcard
  const statusMatches = error?.response?.status === status || status === '*';

  // Check error message, handles Promise-like errors (e.reason)
  // and regular errors (e.message, e.type, e.error_description)
  const messageMatches =
    !errorMessages.filter((item) => item).length ||
    errors?.some(
      (e: any) =>
        errorMessages.includes(e?.reason) ||
        errorMessages.includes(e?.message) ||
        errorMessages.includes(e?.type) ||
        // The only case should be 'ecoconsent.missing' during login
        errorMessages.includes(e?.error_description),
    );

  return statusMatches && messageMatches;
};
